module.exports = __webpack_public_path__ + "static/media/android-chrome-192x192.ed5b1c23.png";